export const getLastCompletedStepLabel = (value) => {
  const checkedValue = parseInt(value, 10);

  switch (true) {
    case checkedValue === 0: return 'רישום ראשוני'
    case checkedValue === 1: return 'בחירת קטגוריה'
    case checkedValue === 2: return 'פרטים אישיים'
    case checkedValue === 3: return 'פרטי התקשרות'
    case checkedValue === 4: return 'פרטי חשבון בנק'
    case checkedValue === 5: return 'תחום עיסוק'
    case checkedValue === 6: return 'הסכם התקשרות'
    case checkedValue === 7: return 'ביטוח לאומי - הקדמה'
    case checkedValue === 8: return 'פרטי ביטוח לאומי'
    case checkedValue === 9: return 'ביטוח לאומי - חתימה'
    case checkedValue === 10: return 'שנת מס הכנסה'
    case checkedValue === 11: return 'מס הכנסה - פירוט הכנסות'
    case checkedValue === 12: return 'מס הכנסה - פירוט ילדים'
    case checkedValue === 13: return 'מס הכנסה - זיכויים ופטורים'
    case checkedValue >= 14: return 'הרשמה הסתיימה'
    default: return ''
  }
};
